/* eslint-disable indent */
import styled, { css } from 'styled-components';

import responsive from 'theme/responsive';

import SearchBox from './SearchBox';

const StyledSearchBox = styled(SearchBox)`
    ${responsive.sm(css`
        flex-basis: 420px;
    `)}

    &.horizontal {
        flex-basis: 100%;
        padding-top: 20px;
    }

    &.vertical {
        padding: 10px;
    }

    &.floating {
        width: 100%;
        border-radius: 34px;
        background-color: ${(props) => props.theme.colours.white};
        box-shadow: 0 2px 24px 10px rgba(0, 0, 0, 0.2);
        padding: 10px;

        ${responsive.sm(css`
            border-radius: ${(props) => props.theme.corners.box.outside}px;
            width: auto;
            padding: 30px;
        `)}
    }

    .form {
        display: flex;
        flex-direction: ${(props) =>
            props.type === 'horizontal' ? 'row' : 'column'};
    }

    .destination-input-container,
    .dates-container,
    .occupancy-container,
    .errors-container {
        margin-bottom: 10px;
        ${(props) => props.type === 'horizontal' && 'margin-right: 20px;'}

        ${responsive.sm(css`
            margin-bottom: 20px;
        `)}
    }

    .destination-input-container {
        flex-grow: 1;
    }

    .dates-container {
        min-width: 300px;

        ${responsive.sm(css`
            min-width: 230px;
        `)}

        ${responsive.md(css`
            min-width: 300px;
        `)}
    }

    .occupancy-container {
        min-width: 275px;

        ${responsive.sm(css`
            min-width: 170px;
        `)}

        ${responsive.md(css`
            min-width: 275px;
        `)}
    }

    /*background-color: ${(props) => props.theme.colours.secondary};
    padding: 15px;
    margin-bottom: 15px;

    .change-search {
        display: flex;
        justify-content: space-between;
        color: #fff;
        
        &.open {
            margin-bottom: 15px;
        }
    }

    .change-search-trigger {
        color: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .trigger-icon {
        transform: rotate(90deg);
        width: 17px;
        height: 17px;
        margin-left: 10px;
    }

    .errors {
        strong {
            font-weight: 600;
        }

        padding: 10px;
        background-color: #dc143c;
        color: #fff;
        border-radius: 3px;
        margin-bottom: 15px;
    }

    &__

    &__label {
        margin-bottom: 10px;
        display: block;
        font-weight: 600;
        font-size: 2rem;
        line-height: 1.7rem;
        color: ${(props) => props.theme.colours.white};
    }

    &__label-subheading {
        color: ${(props) => props.theme.colours.grey};
        font-size: 1.5rem;
        line-height: 1.7rem;
        font-weight: 400;
        display: block;
    }

    &__destination-input-container {
        width: 25%;
    }

    &__dates-container {
        flex-grow: 1;
    }

    &__occupancy-container {
        width: 25%;
    }

    &__submit-container {
        width: 16.66666667%;
        padding-top: 44px;
    }   */
`;

export default StyledSearchBox;
